// Replaces a node's script elements (recursively) with cloned
// versions created via `document.createElement('script')
export const replaceScriptNodes = (node: Element) => {
  if (node.tagName === 'SCRIPT') {
    node.parentNode?.replaceChild(cloneScriptNodes(node), node);
  } else {
    const children = Array.from(node.children);
    children.forEach((child) => {
      replaceScriptNodes(child);
    });
  }
  return node;
};

// Creates a copy of a script node
export const cloneScriptNodes = (node: Element) => {
  const script = document.createElement('script');
  const attrs = Array.from(node.attributes);

  // Copy source attributes to destination Element
  attrs.forEach((attr) => {
    script.setAttribute(attr.name, attr.value);
  });

  // Set script body
  script.text = node.innerHTML;

  return script;
};
